import '@/components/keenicons/assets/duotone/style.css';
import '@/components/keenicons/assets/outline/style.css';
import '@/components/keenicons/assets/filled/style.css';
import '@/components/keenicons/assets/solid/style.css';
import './css/styles.css';

import axios from 'axios';
import ReactDOM from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { App } from './App';
import { setupAxios } from './auth';
import { ProvidersWrapper } from './providers';
import React from 'react';

// import * as Sentry from '@sentry/react';
import { LoadScript } from '@react-google-maps/api';
import { useGetEnvironmentVariableByServiceTypeQuery } from '@/services/EnvironmentVariablesService';
import { ExternalServiceType } from '@/types/environment-variables.types';

// Sentry instrumentation / hardcoded Wappnet DSN temporarily disabled (operator request).
// if (import.meta.env.PROD) {
//   Sentry.init({
//     dsn: '',
//     environment: import.meta.env.VITE_ENV,
//     sendDefaultPii: true,
//   });
// }

/**
 * Inject interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const GoogleMapsLoader: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { data, error } = useGetEnvironmentVariableByServiceTypeQuery(
    ExternalServiceType.VITE_GOOGLE_MAPS_API_KEY
  );

  const apiKey = data?.secret_key;

  if (!apiKey) {
    if (error) {
      console.error('Failed to load Google Maps API key:', error);
    }
    return null;
  }

  return (
    <LoadScript googleMapsApiKey={apiKey} libraries={['places']}>
      {children}
    </LoadScript>
  );
};

root.render(
  // <React.StrictMode>
  // <Sentry.ErrorBoundary fallback={<p>An error has occurred. Please reload the page.</p>}>
    <ProvidersWrapper>
      <GoogleMapsLoader>
        <App />
        <ToastContainer />
      </GoogleMapsLoader>
    </ProvidersWrapper>
  // </Sentry.ErrorBoundary>
  // </React.StrictMode>,
);
